import { useCallback } from "react";
import { useAuthQuery } from "./useAuthQuery";

export const useGetChatList = (queryBody) => {
  const select = useCallback((response) => {
    return (
      response.data?.data?.chats ?? { error: response.data?.error ?? null }
    );
  }, []);

  const response = useAuthQuery(
    {
      method: "POST",
      url: "/chat/list",
      data: queryBody,
    },
    {
      queryKey: ["chat_list", queryBody],
      select,
      refetchOnWindowFocus: false,
    },
  );

  return response;
};
